module.exports = __webpack_public_path__ + "img/icon2.683172ec.png";